import { PROFILE } from "@/data/portfolio";

export function downloadResume() {
  const a = document.createElement("a");
  a.href = PROFILE.resume;
  a.download = "Anish_Ravi_Resume.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
